<div class="card flex-fill"
            [style.--card-color-start]="color"
            [style.--card-color-end]="secondColor">
    <div class="main-img-container">
        <img height="100%" width="100%" class="main-img" [src]="imgUrl" />
    </div>
    <div class="card-body">
       <h4>{{ title | translate }}</h4> 
       <p>{{ text | translate }}</p>
       <button>View</button>
       <div class="top-right-icon">
            <img *ngIf="!isDynamic" height="40" width="40" [src]="cornerIcon" />
            <div *ngIf="isDynamic" class="icon-dynamic">
                <img height="30" width="30" [src]="cornerIcon" />
            </div>
       </div>
    </div>
</div>